/**
 * @module msysMath
 * @description
 * Mosy Math library
 * Provides methods related to mathematical algorithms
 */

const mmath = module.exports = {}

////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * returns intersection of the lines
 */
mmath.lineIntersect = function(line1, line2) {
  const denom = (line2.y2 - line2.y1)*(line1.x2 - line1.x1) - (line2.x2 - line2.x1)*(line1.y2 - line1.y1)
  if(denom === 0) return
  const ua = ((line2.x2 - line2.x1)*(line1.y1 - line2.y1) - (line2.y2 - line2.y1)*(line1.x1 - line2.x1))/denom
  // const ub = ((line1.x2 - line1.x1)*(line1.y1 - line2.y1) - (line1.y2 - line1.y1)*(line1.x1 - line2.x1))/denom
  return {
    x: line1.x1 + ua * (line1.x2 - line1.x1),
    y: line1.y1 + ua * (line1.y2 - line1.y1),
  }
} // lineIntersect

////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * returns places of connection of connecting line between two rectangles
 */
mmath.rectConnections = function(rect1, rect2) {
  rect1 = {
    x: rect1.x,
    y: rect1.y,
    w: rect1.w,
    h: rect1.h,
    x1: rect1.x - rect1.w/2,
    x2: rect1.x + rect1.w/2,
    y1: rect1.y - rect1.h/2,
    y2: rect1.y + rect1.h/2,
  }
  rect2 = {
    x: rect2.x,
    y: rect2.y,
    w: rect2.w,
    h: rect2.h,
    x1: rect2.x - rect2.w/2,
    x2: rect2.x + rect2.w/2,
    y1: rect2.y - rect2.h/2,
    y2: rect2.y + rect2.h/2,
  }

  const connection_line = { x1: rect1.x, y1: rect1.y, x2: rect2.x, y2: rect2.y }
  const angle_atan = Math.abs((rect1.x-rect2.x) / (rect1.y-rect2.y))

  let horizontal_side = angle_atan <= rect1.w/rect1.h
  let side_line = Object.assign({}, rect1)
  let side = horizontal_side ? (rect1.y<rect2.y ? 'bottom' : 'up') : (rect1.x<rect2.x ? 'right' : 'left')
  if(side==='up') side_line.y2=side_line.y1
  else if(side==='bottom') side_line.y1=side_line.y2
  else if(side==='left') side_line.x2=side_line.x1
  else side_line.x1=side_line.x2
  const intersect1 = mmath.lineIntersect(connection_line, side_line)

  horizontal_side = angle_atan <= rect2.w/rect2.h
  side_line = Object.assign({}, rect2)
  side = horizontal_side ? (rect1.y<rect2.y ? 'up' : 'bottom') : (rect1.x<rect2.x ? 'left' : 'right')
  if(side==='up') side_line.y2=side_line.y1
  else if(side==='bottom') side_line.y1=side_line.y2
  else if(side==='left') side_line.x2=side_line.x1
  else side_line.x1=side_line.x2
  const intersect2 = mmath.lineIntersect(connection_line, side_line)

  return {
    x1: intersect1.x,
    y1: intersect1.y,
    x2: intersect2.x,
    y2: intersect2.y,
  }
} // rectConnections
